import { render, staticRenderFns } from "./SolutionAttachments.vue?vue&type=template&id=d9ec3578&"
import script from "./SolutionAttachments.vue?vue&type=script&lang=js&"
export * from "./SolutionAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports